// Concourse comes back on every flight whose gate is mapped to one, but only
// these airports show concourses in the flight tables for now. They both label
// their concourses A, B and C.
const CONCOURSE_AIRPORTS = ["DEN", "CLE"];

export const CONCOURSE_NAMES = ["A", "B", "C"];

export const usesConcourses = (code_iata: string | undefined) =>
  code_iata !== undefined && CONCOURSE_AIRPORTS.includes(code_iata);

// Tab values carry the "Concourse " prefix so they read well as labels; the
// bare name is what a flight's concourse (or gate prefix) is matched against.
export const concourseTabValue = (name: string) => `Concourse ${name}`;

export const concourseFromTabValue = (value: string) =>
  value.replace("Concourse ", "");

// DEN's gates are not mapped to concourses, so fall back to the gate prefix.
export const flightConcourse = (flight: {
  concourse?: string | null;
  gate?: string | null;
}) => flight.concourse ?? flight.gate?.charAt(0);
